import { env } from "../../../core/Env"
import { rqx } from "../../../core/request/API"

export const BranchRead = async (company_id, filter) => {
    try {
        let result = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/branch/read`, {
            company_id: company_id,
            filter: filter
        })
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchCreate = async (company_id, user_id, branch_code, branch_name) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/branch/create`, {
            company_id: company_id,
            user_id: user_id,
            branch_code: branch_code,
            branch_name: branch_name,
        })
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchUpdate = async (company_id, id, user_id, branch_name, active) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/branch/update`, {
            company_id: company_id,
            id: id,
            user_id: user_id,
            branch_name: branch_name,
            active: active,
        })
        return result
    } catch (error) {
        return 'error'
    }
}

export const CategoryRead = async (cid, filter, type) => {
    try {
        let result
        if (filter === 'sub-category') {
            result = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/category/read`, {
                category_id: cid,
                filter: filter,
                type: type
            })
        } else {
            result = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/category/read`, {
                company_id: cid,
                filter: filter,
                type: type
            })
        }
        return result
    } catch (error) {
        return 'error'
    }
}

export const CategoryCreate = async (company_id, user_id, name, sub) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/category/create`, {
            company_id: company_id,
            user_id: user_id,
            name: name,
            sub: sub,
        })
        return result
    } catch (error) {
        return 'error'
    }
}
export const CategoryUpdate = async (company_id, user_id, category_id, category_name, active, sub) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/category/update`, {
            company_id: company_id,
            user_id: user_id,
            category_id: category_id,
            name: category_name,
            active: active,
            sub: sub
        })
        return result
    } catch (error) {
        return 'error'
    }
}

export const ProductRead = async (company_id, filter) => {
    try {
        let result = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/product/read`, {
            company_id: company_id,
            filter: filter
        })
        return result
    } catch (error) {
        return 'error'
    }
}

export const ProductCreate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/product/create`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const ProductUpdate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/product/update`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchProductRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/branchProduct/read`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchProductCreate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/branchProduct/create`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchProductUpdate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/branchProduct/update`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchUserRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/branchUser/read`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchUserCreate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/branchUser/create`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchUserUpdate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/branchUser/update`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const UomRead = async () => {
    try {
        let result = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/uom/read`)
        return result
    } catch (error) {
        return 'error'
    }
}

export const ToolUser = async (company_id) => {
    try {
        // let result = await rqx.get(`<<global>>/${env() === 'local' ? 'prod' : env()}/tooluser/gettooluser`, {company_id: 35, tool_id: 103})
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/tooluser/gettooluser`, { company_id: company_id, tool_id: process.env.REACT_APP_TID_BIZ })
        return result
    } catch (error) {
        return 'error'
    }
}

export const WarehouseRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/warehouse/read`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const WarehouseCreate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/warehouse/create`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const WarehouseUpdate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/warehouse/update`, body)
        return result
    } catch (error) {
        return 'error'
    }
}


export const CompanyProductRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/companyProduct/read`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const CompanyProductCreate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/companyProduct/create`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const CompanyProductUpdate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/companyProduct/update`, body)
        return result
    } catch (error) {
        return 'error'
    }
}


export const WarehouseUserRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/warehouseUser/read`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const WarehouseUserCreate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/warehouseUser/create`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const WarehouseUserUpdate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/warehouseUser/update`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const SupplierRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/supplier/read`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const SupplierCreate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/supplier/create`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const SupplierUpdate = async (body) => {
    try {
        let result = await rqx.post(`<<biz>>/${env() === 'dev' ? 'local' : env()}/biz/supplier/update`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const IndustryRead = async () => {
    try {
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/industry/readall`, { filter: 'all' })
        return result
    } catch (error) {
        return 'error'
    }
}


///USER API'S
export const OrderSave = async (body) => {
    try {
        let result = await rqx.post(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/order/create`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const OrderTransaction = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/order/transaction`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const SalesReportRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/salesreport/read`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const SalesReportSubmit = async (body) => {
    try {
        let result = await rqx.post(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/salesreport/create`, body)
        return result
    } catch (error) {
        return 'error'
    }
}


///ADMIN REPORTS
export const SalesBranchReport = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/report/salesbranch`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const SalesProductReport = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/report/salesproduct`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

// Dashboard
export const BranchSalesChart = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/dashboard/salesbranch`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchProductChart = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/dashboard/productsales`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const PeakHoursRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env() === 'dev' ? 'local' : env()}/biz/dashboard/peakhours`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}


//RECONCILIATION

export const BranchEodRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/reconciliation/brancheodread`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchInvRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/reconciliation/branchinvread`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const ReconcileRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/reconciliation/getreconcile`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const ReconciledSalesRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/reconciliation/getreconciledsales`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const SubmitReconcile = async (body) => {
    try {
        let result = await rqx.post(`<<tool>>/${env()}/biz/reconciliation/submit`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const DeclineReconcile = async (body) => {
    try {
        let result = await rqx.post(`<<tool>>/${env()}/biz/reconciliation/declinerecon`, body)
        return result
    } catch (error) {
        return 'error'
    }
}


// VOUCHER

export const ReadVoucher = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/order/readvoucher`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const RedeemVoucher = async (body) => {
    try {
        let result = await rqx.post(`<<pms>>/${env()}/psl/discount/redeemed_voucher`, body)
        return result
    } catch (error) {
        return 'error'
    }
}


// Personalization 
export const PersonalizationRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<global>>/${env()}/personalization/read`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const PersonalizationCreate = async (body) => {
    try {
        let result = await rqx.post(`<<global>>/${env()}/personalization/create`, body)
        return result
    } catch (error) {
        return 'error'
    }
}


export const StartHereRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/start/read`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

// Tool Usage

export const GetToolUsage = async (qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/readToolUsage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/readToolUsage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const GetToolActivePercentage = async (qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/usagePercentage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/activePercentage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const GetToolAwarePercentage = async (qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/usagePercentage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/awarePercentage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const GetToolUsagePercentage = async (qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/usagePercentage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/usagePercentage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const GetToolMostUsedPage = async (qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/mostUsedPage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/mostUsedPage`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const GetToolUsageDetails = async (qsp) => {
    try {
        // let result = await rqx.post(`<<global>>/${env() === 'dev' ? 'local' : env()}/toolusage/mostUsedPage`, body)
        let result = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/toolusage/usageDetails`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const CreateFeatureLogs = async (body) => {
    try {
        console.log('Feature Log');
        // let result = await rqx.post(`<<global>>/${env()}/trail/featurelogs`, body)
        // return result
    } catch (error) {
        return 'error'
    }
}

export const CompanyInfoRead = async (qsp) => {
    try {
        let result = await rqx.get(`<<biz>>/${env()}/general-maintenance/company/company-setup/getByCompanyId`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const GenerateBill = async (qsp) =>{
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/order/billout`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}


export const CutoffRead = async (qsp) =>{
    try {
        let result = await rqx.get(`<<biz>>/${env()}/biz/cutoff/read`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const CutoffUpdate = async (body) =>{
    try {
        let result = await rqx.post(`<<biz>>/${env()}/biz/cutoff/update`, body)
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchOrderRead = async (qsp) =>{
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/report/branchorder`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}


export const BranchOrderItemRead = async (qsp) =>{
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/report/branchorderitem`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}


export const TotalSalesRead = async (qsp) =>{
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/report/totalsales`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const AdjustedTotalSalesRead = async (qsp) =>{
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/report/adjustedtotalsales`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const BranchSalesRead = async (qsp) =>{
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/report/branchsales`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}


export const DashboardSummaryRead = async (qsp) =>{
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/dashboard/summary`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}


export const DashboardActualSalesRead = async (qsp) =>{
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/dashboard/actualsales`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

export const DashboardTotalSalesRead = async (qsp) =>{
    try {
        let result = await rqx.get(`<<tool>>/${env()}/biz/dashboard/totalsales`, qsp)
        return result
    } catch (error) {
        return 'error'
    }
}

